var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{ref:"console"},[(_vm.appInitialized)?_c('controllerTop'):_vm._e(),_c('statusPanel'),_c('controllerBottom')],1),_c('KeyboardMain')],1)}
var staticRenderFns = []

export { render, staticRenderFns }